import { useTranslation as useTranslationsI18next } from 'react-i18next';

export const useTranslation = (
	ns?: string | undefined,
	options?: {
		keyPrefix: string;
	},
) => {
	const { t, i18n, ready } = useTranslationsI18next(ns, options);

	const translate = (key: string, replaces?: object) => {
		const translation = t(key, replaces!);
		if (translation === `${options?.keyPrefix}/${key}`) {
			return key;
		} else if (key.includes('/')) {
			return key;
		}

		return translation;
	};

	return { t: translate, i18n, ready };
};
